import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { EMPTY_FORM_PAGE_MODEL, FormModel, FormPageModel } from '../../global-data-models/form.model';
import { DEFAULT_FORM_PAGE_OPTIONS, OrderDir, FormService } from '../../global-services/form.service';
import { GlobalMessageService } from '../../global-services/global-message.service';
import { GlobalLoadingService } from '../../global-services/global-loading.service';
import { FormPageOptions } from '../../global-services/form.service';

export interface FormsViewUiState {
  formPage: FormPageModel;
}

const EMPTY_FORMS_VIEW_UI_STATE: FormsViewUiState = { formPage: EMPTY_FORM_PAGE_MODEL };

@Injectable({ providedIn: 'root' })
export class FormsViewFacade {
  private uiState: FormsViewUiState = EMPTY_FORMS_VIEW_UI_STATE;
  private readonly _uiState$ = new BehaviorSubject<FormsViewUiState>(this.uiState);
  public readonly uiState$ = this._uiState$.asObservable();
  private readonly destroy$ = new Subject<void>();

  private pageOptions: FormPageOptions = DEFAULT_FORM_PAGE_OPTIONS;

  public constructor(
    private readonly formService: FormService,
    private readonly messageService: GlobalMessageService,
    private readonly loadingService: GlobalLoadingService,
  ) {}

  public async loadForms(): Promise<void> {
    this.loadingService.show();
    try {
      const _formPage: FormPageModel = await this.formService.getFormsPage(this.pageOptions);
      this._uiState$.next({ formPage: _formPage });
    } catch (error: Error | any) {
      this._uiState$.next(EMPTY_FORMS_VIEW_UI_STATE);
      this.messageService.showError('Get Forms Error', error.message);
    } finally {
      this.loadingService.hide();
    }
  }

  public setFormPageOptions(pageOptions: FormPageOptions) {
    this.pageOptions = pageOptions;
  }

  public destroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
